import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import styles from "./Portfolio.module.css";
import projects from "../data/projects";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12 },
  },
};

const projectKeys = ["qrescue", "mads", "order", "greek", "nutrition", "recreating", "tennis"];

const Portfolio = () => {
  const { lang } = useLang();

  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <motion.div
        className={styles.heroArea}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className={styles.title}>{t("portfolio.title", lang)}</h1>
        <p className={styles.subtitle}>{t("portfolio.subtitle", lang)}</p>
      </motion.div>

      <motion.div
        className={styles.grid}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        variants={staggerContainer}
      >
        {projects.map((proj, index) => {
          const key = projectKeys[index];
          return (
            <motion.div
              key={index}
              className={styles.card}
              variants={fadeUp}
              whileHover={{ y: -5, borderColor: "var(--accent)" }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <h3>{t(`projects.${key}Title`, lang)}</h3>
              <p className={styles.desc}>{t(`projects.${key}Desc`, lang)}</p>
              <div className={styles.tech}>
                {proj.tech.map((tech, i) => (
                  <motion.span key={i} whileHover={{ scale: 1.1 }}>
                    {tech}
                  </motion.span>
                ))}
              </div>
              {proj.link && proj.link !== "#" && (
                <a
                  href={
                    proj.link.startsWith("http")
                      ? proj.link
                      : `https://${proj.link}`
                  }
                  target="_blank"
                  rel="noreferrer"
                  className={styles.projectLink}
                >
                  {t("portfolio.viewProject", lang)}
                </a>
              )}
            </motion.div>
          );
        })}
      </motion.div>

      <motion.div
        className={styles.cta}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        <h3>{t("portfolio.ctaTitle", lang)}</h3>
        <p>{t("portfolio.ctaDesc", lang)}</p>
        <Link to="/contact" className={styles.ctaButton}>
          {t("portfolio.ctaButton", lang)}
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default Portfolio;
